import React, { useEffect, useState } from 'react'
import { db } from '../../firebase/config'
import { collection, getDocs } from 'firebase/firestore'
import {
    TH, TD, Table, Head,
} from './Elements'

const InscriptionList = () => {

    const [data, setData] = useState([])

    useEffect(() => {

        const getData = async () => {
            const temp = []
            const querySnapshot = await getDocs(collection(db, "registered-users"))
            querySnapshot.forEach((doc) => {
                temp.push({name: doc.data().name, surname: doc.data().surname, email: doc.data().email})
            })
            setData(temp)
        }

        getData()

    }, [])

    console.log(data)

    return (
        <Table>
            <Head>
                <tr>
                    <TH>Nombre</TH>
                    <TH>Apellido</TH>
                    <TH>Email</TH>
                </tr>
            </Head>
                <tbody>
                    {
                        data.length !== 0 &&
                        data.map((item, index) => {
                            return(
                                <tr key={index}>
                                    <TD>{item.name}</TD>
                                    <TD>{item.surname}</TD>
                                    <TD>{item.email}</TD>
                                </tr>
                            )
                        })
                    }
                </tbody>
        </Table>
    )
}

export default InscriptionList

